import {useAuth} from 'contexts/AuthContext';
import subscriptionConverter from 'converters/subscriptionConverter';
import {firestore, payments} from 'firebase.js';
import {collection, getDoc, getDocs, query} from 'firebase/firestore';
import {useMemo, useState} from 'react';
import {
  createCheckoutSession,
  getPrices as baseGetPrices,
  getProducts as baseGetProducts
} from "@invertase/firestore-stripe-payments";

export function getProducts() {
  // States
  const [products, setProducts] = useState([])

  // Effects
  useMemo( async () => {
    const fetchedProducts = await baseGetProducts(payments, {
      includePrices: true,
      activeOnly: true,
    })

    setProducts(fetchedProducts)
  }, [])

  return products;
}

export function getPrices(productID) {
  // States
  const [prices, setPrices] = useState([])

  useMemo(async () => {
    const fetchedPrices = await baseGetPrices(payments, productID)
    setPrices(fetchedPrices)
  }, [])

  return prices;
}

export async function startCheckoutSession(userId, price) {
  const session = await createCheckoutSession(payments, {
      price: price.id,
    allow_promotion_codes: price.unit_amount !== null,
      payment_method_collection: 'if_required',
    billing_address_collection: 'auto',
      success_url: `${window.location.origin}?logout=true`,
      cancel_url: window.location.origin,
    mode: price.type === 'one_time' ? 'payment' : 'subscription'
  });
  window.location.assign(session.url);
}

export function getSubscriptions() {
  const {currentUser} = useAuth()
  // States
  const [subscriptions, setSubscriptions] = useState([])

  useMemo(async () => {
    const q = query(query(collection(firestore, `users/${currentUser.uid}/subscriptions`)
      .withConverter(subscriptionConverter)))
    const querySnapshot = await getDocs(q);
    const subscriptionsArr = [];
    querySnapshot.forEach((doc) => {
      const subscriptionData = doc.data()
      subscriptionsArr.push({...subscriptionData, ...{id: doc.id}})
    })
    for await (const subscription of subscriptionsArr) {
      const productSnap = await getDoc(subscription.product);
      subscription.product = productSnap.data()
    }
    setSubscriptions(subscriptionsArr)
  }, [])

  return subscriptions;
}

export async function getPayments(userId) {
  const querySnapshot  = await getDocs(collection(firestore, `users/${userId}/payments`))
  const payments = [];
  querySnapshot.forEach( doc => {
    payments.push(doc.data())
  })
  return payments;
}
